import React from "react";
import { lStorage, lStorageKeys } from '../../../helpers/lStorage';
import Product from "../Product";

class LastViewed extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const lv = lStorage.arrayGet(lStorageKeys.LAST_VIEWED_PRODUCTS);

        const items = [];

        if (lv.length) {
            lv.reverse();

            lv.forEach(function(value) {
                items.push(<React.Fragment key={value.id}>
                    <Product id={value.id} name={value.name} imageId={value.image_id} />
                </React.Fragment>)
            });
        } else {
            items.push('W bieżącej sesji nie przeglądałeś jeszcze żadnego produktu.');
        }

        return <div className="box">
            <div className="header">
                <h3>Ostatnio przeglądane produkty</h3>
            </div>
            <div className="content">
                {items}
            </div>
        </div>
    }
}

export default (LastViewed);